import axios from 'axios';

export interface LocalizedText {
    en: string;
    hu: string;
}

export interface ReferenceSite {
    key: string;
    title: LocalizedText;
    description: LocalizedText;
    image: string;
    url: string;
}

export interface ReferencePartner {
    name: string;
    logo: string;
    /**
     * A logó alt-szövege és tooltipje. A CMS bevezetése előtti kimenetekben még nincs meg,
     * ezért opcionális — hiányában a name szolgál tartaléknak (lásd DesignComponent).
     */
    title?: LocalizedText;
}

export interface ReferencesResponse {
    sites: ReferenceSite[];
    partners: ReferencePartner[];
}

/**
 * A referenciákat ma a dist/data alá másolt statikus JSON adja, de a komponens már
 * aszinkron tölt. Ha valódi backend kerül mögé, elég ezt a konstanst átírni — feltéve,
 * hogy az endpoint ugyanezt a ReferencesResponse alakot adja vissza.
 *
 * Figyelem: valódi API esetén a gyökér .htaccess SPA-rewrite-ját is ki kell egészíteni,
 * mert az minden nem létező fájlt az index.html-re irányít.
 */
const REFERENCES_ENDPOINT = '/data/references.json';

export async function fetchReferences(): Promise<ReferencesResponse> {
    const response = await axios.get<ReferencesResponse>(REFERENCES_ENDPOINT);
    const data = response.data;

    if (!data || !Array.isArray(data.sites) || !Array.isArray(data.partners)) {
        throw new Error('A referencia-válasz nem a várt alakú.');
    }

    return data;
}
